import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-5 py-5" }
const _hoisted_2 = { class: "card card-primary card-outline" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, "Guía", -1)
const _hoisted_4 = { class: "card-body p-0" }

export function render(_ctx, _cache) {
  const _component_web_viewer = _resolveComponent("web-viewer")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_web_viewer, { initialDoc: "/assets/pdf/intrucciones.pdf" })
      ])
    ])
  ]))
}